import {Component} from 'react';
import { func, bool } from 'prop-types';

export default class Container extends Component {
	static propTypes = {
    	render : func.isRequired,
    	refine : func,
    	hasMore : bool,
	}

    onSentinelIntersection = entries => {
    	const { hasMore, refine } = this.props;
    	entries.forEach(entry => {
    		if (entry.isIntersecting && hasMore) {
    			refine();
    		}
    	});
    };

    onReceiveSentinel = (c) => {
    	this.sentinel = c;
    }
    componentWillUnmount() {
    	this.observer.disconnect();
    }
    componentDidMount() {
    	this.observer = new IntersectionObserver(this.onSentinelIntersection);
  
    	this.observer.observe(this.sentinel);
    }
  
    render() {
    	const { render, ...other } = this.props;
    	return render({
    		onReceiveSentinel : this.onReceiveSentinel
    	},other);
    }
}